import { GTCPage } from './GTCPage';

export default GTCPage;
